import { AppError } from './AppError'

export function logError(
  error: AppError,
  context?: Record<string, unknown>
): void {
  if (process.env.NODE_ENV === 'development') {
    console.error('[AppError]', {
      code: error.code,
      message: error.message,
      userMessage: error.userMessage,
      originalError: error.originalError,
      stack: error.stack,
      context,
    })
  }

  // Future: Send to external error tracking service
  // Example: Sentry, LogRocket, etc.
  // if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  //   Sentry.captureException(error.originalError || error, {
  //     tags: { errorCode: error.code },
  //     extra: context,
  //   })
  // }
}
